import { Component } from '@angular/core';
import { BookDemoService } from '../../../dialogs/book-demo-dialog/book-demo.service';

@Component({
  selector: 'app-ts-v2-cta-section',
  templateUrl: './cta-section.component.html',
  styleUrls: ['./cta-section.component.scss'],
})
export class V2CtaSectionComponent {
  constructor(private bookDemo: BookDemoService) {}

  openBookDemo(): void {
    this.bookDemo.open();
  }
}
